(() => {
  async function loadRecommendations(element) {
    if (element.dataset.recommendationsPerformed === 'true') return;

    const { url, productId, sectionId, intent } = element.dataset;
    if (!url || !productId || !sectionId) return;

    const params = new URLSearchParams({
      product_id: productId,
      section_id: sectionId,
      intent: intent || 'related',
    });

    try {
      const response = await fetch(`${url}&${params}`);
      if (!response.ok) throw new Error(`Server returned ${response.status}`);

      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const recommendations = documentFragment.querySelector('sparesczar-product-recommendations');

      if (!recommendations?.innerHTML.trim()) {
        element.hidden = true;
        return;
      }

      element.innerHTML = recommendations.innerHTML;
      element.dataset.recommendationsPerformed = 'true';
    } catch (error) {
      console.error('Product recommendations error:', error.message);
      element.dataset.error = 'Error loading product recommendations';
      element.hidden = true;
    }
  }

  function initializeRecommendations() {
    document.querySelectorAll('sparesczar-product-recommendations').forEach(loadRecommendations);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeRecommendations, { once: true });
  } else {
    initializeRecommendations();
  }

  document.addEventListener('shopify:section:load', initializeRecommendations);
})();
